class MBiznes16 {

    constructor() {
        this.init();
    }

    private init() {
       this.setFormFields();
       this.panelForm();
       this.menu();
       this.scrollView();
//        this.hideButtons();  // disabled because of DEVA-4820
    }

    private setFormFields() {
        let clauseInput = document.querySelector('.clauseInput');
        if(clauseInput) {
            let clauseField = clauseInput.parentElement;
            clauseField.classList.add('clause');
    
            let shortClause = document.createElement('div');
            shortClause.classList.add('shortClause');
    
            let text = document.createElement('div');
            text.classList.add('shortClauseText');
            text.innerHTML = 'Administratorem danych osobowych jest Bonnier Business (Polska) Sp. z o. o , ul. Kijowska 1, 03-738 Warszawa&nbsp;';
            
            let showMore = document.createElement('div');
            showMore.innerHTML = '(rozwiń)';
            showMore.classList.add('shortClauseButton');
            showMore.addEventListener('click', function() {
                clauseField.classList.add('-show');
            });

            text.append(showMore);
            shortClause.append(text);
            clauseField.append(shortClause);
        }

        let regulationInput = document.querySelector('.regulationInput');
        if(regulationInput) {
            let regulationField = regulationInput.parentElement;
            regulationField.classList.add('regulation');
        }
    }

    private panelForm() {
        let rodoExpandButton = document.querySelector('.bs-rodo-expand');
        let rodoShortText = document.querySelector('.bs-rodo-short');
        let rodoLongText = document.querySelector('.bs-rodo-long');

        if(rodoExpandButton) {
            rodoExpandButton.addEventListener('mouseover', function() {
                (rodoExpandButton as HTMLElement).style.display = 'none';
                (rodoShortText as HTMLElement).style.display = 'none';
                (rodoLongText as HTMLElement).style.display = 'inline-block';
            });
        }
    }

    private menu() {
        let menuHamburger = document.querySelector('.header-hamburger');
        let menuButtons = document.querySelector('.header-buttons');
        menuHamburger.addEventListener('click', function() {
            if(menuButtons.classList.contains('show')) {
                menuButtons.classList.remove('show');
            } else {
                menuButtons.classList.add('show');
            }
        });
    }

    private scrollView() {

        let url = window.location.pathname;
        let hash = window.location.hash;

        if (url.indexOf('zaloguj') !== -1) {
            let loginForm = document.querySelector('.login-form')
            window.scrollTo({
                top: (loginForm as HTMLElement).offsetTop,
                left: 0,
                behavior: 'smooth'
            });
        } else if (url.indexOf('zmien-haslo') !== -1) {
            let passwordForm = document.querySelector('.password-form')
            window.scrollTo({
                top: (passwordForm as HTMLElement).offsetTop,
                left: 0,
                behavior: 'smooth'
            });
        } else if (hash.indexOf('#register-form') !== -1) {
            let registerForm = document.getElementById('register-form');
            let registerMessage = document.querySelector('.register-message');
            let offset = 0;
            if(registerForm) {
                offset = (registerForm as HTMLElement).offsetTop;
            } else {
                offset = (registerMessage as HTMLElement).offsetTop;
            }
            window.scrollTo({
                top: offset - 100,
                left: 0,
                behavior: 'smooth'
            });
        }
    }

    private hideButtons() {
        let lead_buttons = document.querySelectorAll('.bs-btn-submit');
        let lead_blocked = document.querySelector('#bs-elead-blocked') as HTMLElement
        for(let i = 0; i < lead_buttons.length; i++) {
            lead_buttons[i].addEventListener('click', function() {
                (document.querySelector('.bs-btn-wrapper') as HTMLElement).style.display = 'none';
                if(lead_blocked) {
                    lead_blocked.style.display = 'block';
                }
                let info_product = document.querySelector('.info-product') as HTMLElement;
                if(info_product) {
                    info_product.style.display = 'none';
                }
            });
        }
    }
}

let mBiznes16 = new MBiznes16();
